import angular from 'angular';
import uiRouter from 'angular-ui-router';
import locationsComponent from './locations.component';

let locationsModule = angular.module('locations', [
  uiRouter
])

.component('locations', locationsComponent)

.name;

export default locationsModule;
